import React from 'react';
import { CategoryPicker } from './CategoryPicker';
import { TagPicker } from './TagPicker';
import type { TagProps } from '../atoms/Tag';

type TagSelectorProps = {
  tags: { [category: string]: { id: string; name: string }[] };
  selectedTags: string[];
  onTagToggle: (tagId: string, category: string) => void;
  selectedCategory: string | null;
  showFilters: boolean;
  setSelectedCategory: React.Dispatch<React.SetStateAction<string | null>>;
};

const CATEGORY_MAP: Record<string, TagProps['category']> = {
  DIET: 'diet',
  CUISINE: 'cuisine',
  MEAL_TYPE: 'meal',
  OCCASION: 'occasion',
  SEASON: 'season',
  NUTRITION: 'nutrition',
  COST_AND_EFFORT: 'cost',
  SPICE_LEVEL: 'spice',
};

const LABEL_MAP: Record<string, string> = {
  DIET: 'Diet',
  CUISINE: 'Cuisine',
  MEAL_TYPE: 'Meal Type',
  OCCASION: 'Occasion',
  SEASON: 'Season',
  TECHNIQUE: 'Technique',
  NUTRITION: 'Nutrition',
  COST_AND_EFFORT: 'Cost & Effort',
  SPICE_LEVEL: 'Spice Level',
};

export default function TagSelector({
  tags,
  selectedTags,
  onTagToggle,
  selectedCategory,
  showFilters,
  setSelectedCategory,
}: TagSelectorProps) {
  // build category list
  const categoryList = Object.keys(tags).map((cat) => ({
    key: cat,
    label: LABEL_MAP[cat] ?? cat,
  }));

  return (
    <div className="space-y-0">
      {showFilters && (
        <CategoryPicker
          categories={categoryList}
          selected={selectedCategory}
          onSelect={setSelectedCategory}
          size="sm"
        />
      )}

      {showFilters && selectedCategory && (
        <TagPicker
          categoryKey={CATEGORY_MAP[selectedCategory] ?? 'diet'}
          tags={tags[selectedCategory] || []}
          selected={selectedTags}
          onToggle={(tagId) => onTagToggle(tagId, selectedCategory)}
          size="sm"
        />
      )}
    </div>
  );
}
